export default {
  'Custom': 'Custom',
  'Original': 'Original',
  'Resolution': 'Resolution',
  'Frame rate': 'Frame rate',
  'The higher the frame rate, the smoother the animation': 'The higher the frame rate, the smoother the animation',
  'Start': 'Start',
  'End': 'End',
  'Create GIF': 'Create GIF',
  'Download GIF': 'Download GIF',
  'Create A New One': 'Create A New One',
  'Remake GIF': 'Remake GIF',
  'HitPaw Video to GIF Online': 'HitPaw Video to GIF Online',
  'Upload and convert video to GIF without any difficulty': 'Upload and convert video to GIF without any difficulty.',
}